import { useReferencePage, useReferenceRecord } from './references';

/**
 * The display name of a referenced record in a list cell: from the resource's first records, else (a large resource) the record
 * fetched by id; its id while that loads or when it can't be found.
 */
export function ReferenceLabel({ resourceKey, value }: { resourceKey?: string; value: unknown }) {
  const page = useReferencePage(resourceKey);
  const id = value == null || value === '' ? undefined : String(value);
  const known = id ? page.data?.options.find((option) => option.value === id) : undefined;
  const record = useReferenceRecord(
    resourceKey,
    id,
    Boolean(id) && Boolean(page.data) && !known && !page.data?.complete,
  );
  if (!id) return null;
  return <>{known?.label ?? record.data?.label ?? id}</>;
}
